module.exports = __webpack_public_path__ + "media/images/icon_list/movie-08628521374e0d13d08dc9562cae605f.svg";